import script from "./ChargesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChargesView.vue?vue&type=script&setup=true&lang=js"

import "./ChargesView.vue?vue&type=style&index=0&id=275d54d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275d54d4"]])

export default __exports__